import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useUser } from "../context/UserContext";
import { applyJourneyOrgToAuthorizationParams } from "../config";

const Login = () => {
  const { selectedJourney, setSelectedJourney, selectedLocale, getClientConfig } = useUser();
  const { loginWithRedirect } = useAuth0();
  const { search } = useLocation();
  const [redirected, setRedirected] = useState(false);

  // Pick up ?journey=... from the query string and store it
  useEffect(() => {
    const params = new URLSearchParams(search);
    const journey = params.get("journey");
    if (journey) setSelectedJourney(journey);
  }, [search, setSelectedJourney]);

  // Trigger Auth0 login once we know the journey (and only once)
  useEffect(() => {
    if (redirected) return;
    if (!selectedJourney) return;

    const params = new URLSearchParams(search);
    const authorizationParams = { ui_locales: selectedLocale };

    // Pass through all URL params (e.g. invitation, organization, and extras)
    params.forEach((value, key) => {
      if (key !== "error" && key !== "error_description" && key !== "journey") {
        authorizationParams[key] = value;
      }
    });

    const withOrg = applyJourneyOrgToAuthorizationParams(
      authorizationParams,
      getClientConfig()
    );

    (async () => {
      await loginWithRedirect({ authorizationParams: withOrg });
      setRedirected(true);
    })();
  }, [redirected, selectedJourney, selectedLocale, loginWithRedirect, search, getClientConfig]);

  if (!selectedJourney) {
    return <div>Please select a journey first</div>;
  }

  return <div>Redirecting...</div>;
};

export default Login;
